import { Pipe, PipeTransform } from '@angular/core';

/**
 * Display-only mapping for B2B network / business type values.
 * The backend stores the canonical "Client_Supplier"; the UI must show "Client/Supplier".
 * Every other value (Client, Supplier, N/A, null) is returned as-is.
 * Nothing here changes the stored value — apply it only at render time.
 *
 * Legacy "Customer/Supplier" rows are folded in too (2026-09-21): the mutual
 * Business Type filter matches every stored spelling, so those rows are now
 * reachable from the listing and must not read as a fourth type.
 */
@Pipe({
  name: 'networkTypeLabel',
  standalone: true
})
export class NetworkTypeLabelPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    const normalized = value.trim().toLowerCase();
    return (normalized === 'client_supplier'
         || normalized === 'customer/supplier'
         || normalized === 'customer_supplier')
      ? 'Client/Supplier'
      : value;
  }
}
